<template>
  <div class="animated fadeIn">
    <div class="card card-blue">
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-2">
            <b-form-input :placeholder="$t('SEARCH')" v-model="searchQuerry" type="text" ></b-form-input>
          </div>
          <div class="col-10">
            <button type="button" class="btn btn-primary button-add pull-right" @click="showModal()">{{$t('NEW')}}</button>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 table-responsive">
              <table class="table table-sm table-bordered table-striped table-hover table-logoped">
                <thead>
                  <tr>
                    <th>
                      <sortingcolumn v-model="pagination" field="name" v-on:reload="getData">{{$t('NAME')}}</sortingcolumn>
                    </th>
                    <th>
                      <sortingcolumn v-model="pagination" field="surname" v-on:reload="getData">{{$t('SURNAME')}}</sortingcolumn>
                    </th>
                    <th>
                      <sortingcolumn v-model="pagination" field="contactNumber" v-on:reload="getData">{{$t('CONTACTNUMBER')}}</sortingcolumn>
                    </th>
                    <th>
                      <sortingcolumn v-model="pagination" field="email" v-on:reload="getData">{{$t('EMAIL')}}</sortingcolumn>
                    </th>
                    <th>{{$t('ACTION')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="item in response.root">
                    <tr :key="item.parentsId" aria-rowindex="1" class=" table-ellipsis">
                      <td>{{item.name}}</td>
                      <td>{{item.surname}}</td>
                      <td>{{item.contactNumber}}</td>
                      <td>{{item.email}}</td>
                      <td>
                        <button type="button" class="btn button-save mr.2" v-if="item.userId == null"  @click="createAcc(item)">{{$t('CREATEACOUNT')}}</button>
                        <button type="button" class="btn button-edit mr-2" v-else  @click="changeParentPassword(item)">{{$t('CHANGEPASSWORD')}}</button>
                        <button type="button" class="btn button-edit mr-2" v-if="item.userId != null" @click="showNotificationModal(item)">{{$t('NOTIFICATION')}}</button>
                        <button type="button" class="btn button-edit mr-2"  @click="showModal(item)">{{$t('EDIT')}}</button>
                        <button type="button" class="btn button-dlt" @click="deleteRow(item.parentsId)">{{$t('DELETE')}}</button>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
              <nav>
                <pagination
                  v-bind:totalCount="response.totalCount"
                  v-model="pagination"
                  v-on:reload="getData"></pagination>
              </nav>
          </div>
        </div>
      </div>
    </div>
    <b-modal ref="formmodal" :title="$t('PARENTFORM')" ok-title="submit" hide-footer no-close-on-backdrop>
      <div class="d-block">
        <parentsform v-bind:formData="formData" v-bind:formError="formError"></parentsform>
      </div>
      <div class="text-right">
        <b-btn class="button-cancel mr-2" @click="hideModal()">{{$t('CANCEL')}}</b-btn>
        <b-btn class="button-save" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
      </div>
    </b-modal>
    <b-modal ref="formnotificationmodal" :title="$t('NOTIFICATION')" ok-title="submit" centered hide-footer no-close-on-backdrop>
      <div class="d-block">
        <notificationmodal
          v-bind:formData="notificationFormData"
          v-bind:formError="formNotificationError"></notificationmodal>
      </div>
      <div class="text-right">
        <b-btn class="mr-2 button-cancel" @click="hideNotificationModal()">{{$t('CANCEL')}}</b-btn>
        <b-btn class="button-save" @click="sendNotification(notificationFormData)">{{$t('SENDNOTIFICATION')}}</b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Api from '@/api/parents/Parents';
import ParentsForm from './Form.vue';
import NotificationModal from '../admin/NotificationModal.vue';

export default
{
    name: 'Parents',
    components:
  {
      parentsform: ParentsForm,
      notificationmodal: NotificationModal,
  },
    data()
    {
        return {
            response:
      {},
      searchQuerry: '',
            formError:
      {},
            formData:
      {
          name: '',
          surname: '',
          contactNumber: '',
          email: '',
      },
            pagination:
      {
          query: '',
          currentPage: 1,
          limit: 25,
          searchTimeout: false,
      },
            formNotificationError: {},
            notificationFormData:
        {
            title: '',
            text: '',
        },
        };
    },
    created()
    {
        const me = this;
        me.getData();
    },
    methods:
  {
      async getData()
      {
          const me = this;
          try
          {
              const data = await Api.selectRow(me.getParams);
              if (data.error && data.error === true)
              {
                  me.$notify.notice(data);
                  me.loading = false;
                  return;
              }

              me.response = data;
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      async sendNotification(item)
      {
          const me = this;
          try
          {
              const data = await Api.sendNotification(item);
              if (data.error)
              {
                  me.$notify.notice(data);
                  me.formError = data;
              }
              else
              {
                  me.$notify.notice(data);
                  me.hideNotificationModal();
              }
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      async deleteRow(id)
      {
          const me = this;
          try
          {
              me.$store.commit('setModalAlert',
                  {
                      text: me.$i18n.t('AREYOUSHURE'),
                      async btnAction()
                      {
                          const data = await Api.deleteRow(
                              {
                                  id,
                              },
                          );
                          me.$notify.notice(data);
                          await me.getData();
                      },
                  });
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      showModal(item)
      {
          const me = this;
          if (typeof item !== 'undefined')
          {
              me.formData = item;
          }
          this.$refs.formmodal.show();
      },
      showNotificationModal(item)
      {
          const me = this;
          me.$set(me.notificationFormData, 'userId', item.userId);
          me.$refs.formnotificationmodal.show();
      },
      async submitData(item)
      {
          const me = this;
          try
          {
              if (typeof item.parentsId !== 'undefined')
              {
                  item.id = item.parentsId;
                  delete (item.parentsId);
              }

              const data = await Api.submitData(item);
              if (data.error)
              {
                  me.$notify.notice(data);
                  me.formError = data;
              }
              else
              {
                  me.$notify.notice(data);
                  me.hideModal();
                  await me.getData();
              }
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      hideModal()
      {
          const me = this;
          this.$refs.formmodal.hide();

          me.formData = {
              name: '',
              surname: '',
              contactNumber: '',
              email: '',
          };
      },
      async createAcc(item)
      {
          const me = this;
          try
          {
              const data = await Api.createUserAccount(item);
              me.$notify.notice(data);
              await me.getData();
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      async changeParentPassword(item)
      {
          const me = this;
          try
          {
              const data = await Api.changeParentPassword(item);
              me.$notify.notice(data);
              await me.getData();
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      hideNotificationModal()
      {
          const me = this;
          this.$refs.formnotificationmodal.hide();

          me.notificationFormData = {
              title: '',
              text: '',
          };
      },
  },
    watch:
  {
      'pagination.limit'()
      {
          const me = this;
          me.getData();
      },
      'pagination.currentPage'()
      {
          const me = this;
          me.getData();
      },
      'pagination.query'()
      {
          const me = this;

          if (me.pagination.searchTimeout !== false)
          {
              clearTimeout(me.pagination.searchTimeout);
          }

          me.pagination.searchTimeout = setTimeout(() =>
          {
              me.getData();
              me.pagination.searchTimeout = false;
          }, 300);
      },
      searchQuerry()
      {
        const me = this;

        if (me.searchTimeout !== false)
        {
            clearTimeout(me.searchTimeout);
        }

        me.searchTimeout = setTimeout(() =>
        {
            me.getData();
            me.searchTimeout = false;
        }, 300);
      }
  },
    computed:
  {
      getParams()
      {
          const me = this;
          const data = {
              ...me.pagination,
          };
          data.searchQuerry = me.searchQuerry;
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
  },
};
</script>
